<div class="product-list-data-right min-h-356">
  <div class="title-box product-category-title-box">
    @if (!zoneData && !areaData && !divisionData && showBreadcrumbs) {
      <p class="heading-data">
        <a href="/">Myescort.dk </a>
        <span> > {{ 'PRODUCT_LIST.SEX_ADS_IN_MYESCORT' | translate }}</span>
      </p>
    }
    @if ((zoneData || areaData || divisionData) && showBreadcrumbs) {
      <p class="heading-data">
        <a href="/">Myescort.dk </a>
        <span>
          > {{ 'PRODUCT_LIST.SEX_ADS_IN' | translate }}
          @if (zoneData && !divisionData) {
            <span>{{ zoneData }}</span>
          }
          @if (areaData && !divisionData) {
            <span>{{ areaData }}</span>
          }
          @if (divisionData) {
            <span>{{ divisionData }}</span>
          }
        </span>
      </p>
    }
    @if (divisionData) {
      <h2>
        {{ 'PRODUCT_LIST.ALL_SEX_ADS_IN' | translate }} {{ divisionData }}
      </h2>
    }
    @if (areaData && !divisionData) {
      <h2>{{ 'PRODUCT_LIST.ALL_SEX_ADS_IN' | translate }} {{ areaData }}</h2>
    }
    @if (zoneData && !divisionData) {
      <h2>{{ 'PRODUCT_LIST.ALL_SEX_ADS_IN' | translate }} {{ zoneData }}</h2>
    }
    @if (!zoneData && !areaData && !divisionData && title) {
      <h2>
        {{ title }}
      </h2>
    }
    @if (description) {
      <p>{{ description }}</p>
    }
    <div class="line"></div>
  </div>

  <div class="product-list-main">
    <div class="all-product-item-cards">
      @for (data of productData; track data.id) {
        <app-marketplace-advert-card
          [advert]="data"></app-marketplace-advert-card>
      } @empty {
        <div>
          <p style="text-align: center !important; padding-bottom: 23px">
            {{ 'PRODUCT_LIST.EXPLORE_MORE_OPTIONS' | translate }}
          </p>
        </div>
      }
    </div>
    @if (showLoadMore && totalAdverts > productData.length) {
      <div class="load-more" style="margin-top: 38px">
        <a (click)="onLoadMore()" class="button" [class.loading]="isLoadMore">
          {{
            totalAdverts > productData.length
              ? ('PRODUCT_LIST.LOAD_MORE' | translate)
              : ''
          }}
        </a>
      </div>
    }
  </div>
</div>
